var _rect, _path, _path2, _path3, _g, _rect2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdverseMediaCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 44,
    viewBox: "0 0 56 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 44,
    rx: 6.27728,
    fill: "#3158F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1488 27.3582L50.0514 34.1882C50.5049 34.982 49.9316 35.9701 49.0175 35.9701H41.2123C40.2976 35.9701 39.7244 34.982 40.1784 34.1882L44.081 27.3582C44.5381 26.5577 45.6917 26.5577 46.1488 27.3582Z",
    fill: "#F48D53",
    stroke: "#F48D53",
    strokeWidth: 0.764321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1136 33.4655C45.0433 33.4655 44.9863 33.5226 44.9868 33.5929C44.9868 33.6632 45.0438 33.7203 45.1142 33.7203C45.1845 33.7203 45.2415 33.6632 45.2415 33.5929C45.2415 33.5226 45.1845 33.4655 45.1136 33.4655",
    stroke: "white",
    strokeWidth: 1.0191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1141 31.9331V30.0273",
    stroke: "white",
    strokeWidth: 1.0191,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    width: 8,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 17,
    width: 4,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 13,
    width: 21,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 7,
    width: 10,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.7891,
    y: 31.5488,
    width: 10.101,
    height: 2.10356,
    rx: 1.05178,
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26172,
    y: 5.95898,
    width: 15.7397,
    height: 15.7397,
    rx: 3.14795,
    fill: "#D0D7E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8296 17.5754H10.3333C10.0998 17.575 9.91058 17.3858 9.91016 17.1522V16.809C9.91308 15.8323 10.7044 15.0413 11.6811 15.0388H14.4818C15.4585 15.0413 16.2498 15.8323 16.2527 16.809V17.1522C16.2523 17.3858 16.0631 17.575 15.8296 17.5754Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0834 13.3874C12.1386 13.3874 11.3724 12.6221 11.3711 11.6773C11.3698 10.7325 12.1341 9.96518 13.0789 9.96265C14.0237 9.96014 14.792 10.7234 14.7958 11.6682C14.7972 12.1234 14.6175 12.5604 14.2962 12.883C13.975 13.2055 13.5386 13.387 13.0834 13.3874Z",
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdverseMediaCheckLarge);
export default __webpack_public_path__ + "static/media/adverse_media_check_large.031dde6a77c8e60485cd67d175617e25.svg";
export { ForwardRef as ReactComponent };